"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_GLYPH_KINDS_V1 = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_enums_colors_1 = require("@gcloud-npm/utils.enums.colors");
let API = "{host}/api/v1/get-glyph";
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const ICON_GLYPH_KINDS = ["s", "m", "l"];
exports.ICON_GLYPH_KINDS_V1 = {
    S: 's',
    M: 'm',
    L: 'l'
};
const checkPropNull = (prop) => {
    return prop === null || prop === 0 || prop === '0' || prop === "";
};
const checkKind = (id) => {
    // Si no se proporciona un sufijo (kind), establecer el valor por defecto como "m"
    if (!id.includes("-")) {
        id += "-m";
    }
    const words = id.split("-");
    const validKinds = ICON_GLYPH_KINDS;
    const suffix = words.pop();
    if (validKinds.includes(suffix)) {
        return id;
    }
    else {
        return id + '-m';
    }
};
const buildId = (id, kind) => {
    let correctId = null;
    // Para los casos que viene el Id sin '-' y en camel case
    if (/[A-Z]/.test(id)) {
        correctId = id.split(/(?=[A-Z])/).join('-');
        correctId.toLowerCase();
    }
    if (kind && correctId) {
        id = `${correctId}-${kind}`;
    }
    else if (kind && !correctId) {
        id = `${id}-${kind}`;
    }
    else if (!kind && correctId) {
        id = checkKind(correctId);
    }
    else {
        id = checkKind(id);
    }
    return id;
};
/**
 * Componente que permite dibujar un icono
 */
const IconGlyph = (props) => {
    let { id, color, className, priority, kind, alt, title, cms, cmsHandler } = props;
    let { width, height, insetPosition, dataCy, layoutSize, backgroundColor, circleLayout } = props;
    const finalBackgroundColor = backgroundColor ? (0, utils_enums_colors_1.getColor)(backgroundColor) : 'transparent';
    const thereIsCircleLayout = (circleLayout && parseInt(circleLayout, 10) > 0);
    let finalCircleLayout = thereIsCircleLayout ? {
        borderRadius: `${(height && height !== 'auto') ? height : width}px`,
        padding: `${thereIsCircleLayout ? `${circleLayout}px` : '0px'}`
    } : {};
    const finalId = buildId(id, kind);
    if (!dataCy) {
        dataCy = `${id}`;
    }
    const size = {};
    let finalTitle = "";
    if (title) {
        finalTitle = title;
    }
    if (currentEnv !== 'prod') {
        // API = API.replace('{host}', 'https://dev.ssr.col.movistar.es');
        API = API.replace('{host}', 'https://ssr.col.movistar.es');
    }
    else {
        API = API.replace('{host}', 'https://ssr.col.movistar.es');
    }
    /* Damos valor a la otra coordenada en caso de no indicarse */
    if (width && !height) {
        // Si no está definido el height se le da el valor del width 
        size.height = width;
        if (!layoutSize || !layoutSize.height) {
            layoutSize = Object.assign(Object.assign({}, layoutSize), { width });
        }
    }
    else if (height && !width) {
        // Si no está definido el width se le da el valor del height 
        size.width = "auto";
        if (!layoutSize || !layoutSize.width) {
            layoutSize = Object.assign(Object.assign({}, layoutSize), { height });
        }
    }
    else if (width && height) {
        // Si ambos están definidos y son diferentes, establecer ambos como el valor de width
        size.width = width;
        size.height = height;
        if (insetPosition) {
            layoutSize = { width, height };
        }
    }
    let loadingAttribute = 'eager';
    let fetchPriorityAttribute = 'high';
    if (!priority) {
        loadingAttribute = 'lazy';
        fetchPriorityAttribute = 'none';
    }
    let finalClassName = 'svg-layout-size';
    if (className) {
        finalClassName = `${finalClassName} ${className}`;
    }
    if (cms && cmsHandler) {
        finalClassName = `${finalClassName} element-editable`;
    }
    let finalAlt = alt || '';
    if (!finalAlt && finalId) {
        finalAlt = finalId;
    }
    // cms placeholder
    if (cms && ((id === "" || id === 'none') || checkPropNull(width))) {
        if (cmsHandler) {
            return (react_1.default.createElement("div", { className: `${finalClassName} cms-icon-placeholder`, style: Object.assign(Object.assign(Object.assign({}, (layoutSize || {})), finalCircleLayout), { backgroundColor: finalBackgroundColor }), onClick: () => cmsHandler(Object.assign(Object.assign({}, props), { name: 'icon-glyph' })) },
                react_1.default.createElement("img", { title: finalTitle, src: `${API}/soporte-tecnico-m/20/white`, width: 20, height: 20 })));
        }
        else
            return null;
    }
    if (!id || id === 'none') {
        return null;
    }
    return (react_1.default.createElement("div", { className: finalClassName, style: Object.assign(Object.assign(Object.assign({}, (layoutSize || {})), finalCircleLayout), { backgroundColor: finalBackgroundColor }), onClick: cms && cmsHandler ? () => cmsHandler(Object.assign(Object.assign({}, props), { name: 'icon-glyph' })) : null },
        react_1.default.createElement("img", { title: finalTitle, "data-cy": dataCy, src: `${API}/${finalId}/${size.height || height}/${color}`, width: size.width || width, height: size.height || height, style: Object.assign(Object.assign({}, insetPosition), { height: size.height || height, width: size.width || width }), alt: finalAlt, loading: loadingAttribute, fetchpriority: fetchPriorityAttribute })));
};
exports.default = IconGlyph;
IconGlyph.propTypes = {
    /**
     * {
     *  "info": "Nombre de icono y trazo a mostrar.",
     *  "kind": "both",
     *  "beautifulName": "Id de icono"
     * }
     */
    id: prop_types_1.default.string,
    /**
     * {
     *  "info": "Colorres que tendrá el icono",
     *  "kind": "both",
     *  "beautifulName": "Colores para cada trazo"
     * }
     */
    color: prop_types_1.default.string,
    /**
     * {
     *  "info": "Classnames que heredará el componente, sirve para aplicar estilos",
     *  "kind": "dev",
     *  "beautifulName": "ClassName"
     * }
     */
    className: prop_types_1.default.string,
    /**
     * {
     *  "info": "Añade etiqueta dom para priorizar su carga, útil si dicho icono, está visible, en el aterrizaje a una página",
     *  "kind": "dev",
     *  "beautifulName": "Carga prioritaria"
     * }
     */
    priority: prop_types_1.default.bool,
    /**
     * {
     *  "info": "Tipo de trazo del icono",
     *  "kind": "both",
     *  "beautifulName": "Trazo",
     *  "values": "./index.js:ICON_GLYPH_KINDS_V1"
     * }
     */
    kind: prop_types_1.default.string,
    /**
     * {
     *  "info": "Texto alternativo del icono para accesibilidad",
     *  "kind": "dev",
     *  "beautifulName": "Alt"
     * }
     */
    alt: prop_types_1.default.string,
    /**
     * {
     *  "info": "Ancho en píxeles del icono. Obligatorio excepto cuando se especifica el height o layoutSize.",
     *  "kind": "both",
     *  "beautifulName": "Ancho"
     * }
     */
    width: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    /**
     * {
     *  "info": "Alto en píxeles del icono. Obligatorio excepto cuando se especifica el width o layoutSize.",
     *  "kind": "dev",
     *  "beautifulName": "Altura"
     * }
     */
    height: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
    /**
     * {
     *  "info": "Cadena que identifica inequívocamente el componente, para finalidades de testing",
     *  "kind": "dev",
     *  "beautifulName": "cyData"
     * }
     */
    dataCy: prop_types_1.default.string,
    /**
     * {
     *  "info": "Colorea el lienzo, en principio invisible del icono.",
     *  "kind": "both",
     *  "beautifulName": "Color del Fondo"
     * }
     */
    backgroundColor: prop_types_1.default.string,
    /**
     * {
     *  "info": "Redondea el lienzo, este aumentara la altura con el valor indicado, creando un contorno entre el icono y la circunferencia",
     *  "kind": "both",
     *  "beautifulName": "Redondear"
     * }
     */
    circleLayout: prop_types_1.default.number,
    /**
     * {
     *  "info": "Objeto que define al tamaño al lienzo que contiene dicho icono",
     *  "kind": "dev",
     *  "beautifulName": "Tamaño lienzo"
     * }
     */
    layoutSize: prop_types_1.default.shape({
        w: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
        h: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    }),
    /**
     * {
     *  "info": "Objeto con información sobre las propiedades necesarias (id, timestamp...) para editar los valores en orion.",
     *  "kind": "dev",
     *  "beautifulName": "CMS"
     * }
     */
    cms: prop_types_1.default.object,
    /**
     * {
     *  "info": "Handler para eventos del CMS. Se ejecuta cuando se clicka en el componente desde el CMS.",
     *  "kind": "dev",
     *  "beautifulName": "CMS Handler"
     * }
     */
    cmsHandler: prop_types_1.default.func,
};
//# sourceMappingURL=index.js.map